export enum WebVitalMetricName {
    CLS = 'CLS',
    FCP = 'FCP',
    INP = 'INP',
    LCP = 'LCP',
    TTFB = 'TTFB',
}

export enum WebVitalRating {
    GOOD = 'good',
    NEEDS_IMPROVEMENT = 'needs-improvement',
    POOR = 'poor',
}

export enum WebVitalNavigationType {
    NAVIGATE = 'navigate',
    RELOAD = 'reload',
    BACK_FORWARD = 'back-forward',
    BACK_FORWARD_CACHE = 'back-forward-cache',
    PRERENDER = 'prerender',
    RESTORE = 'restore',
}
